import * as ww from '@wecom/jssdk'
import * as http from '@/utils/http.js'

export async function getAuthUrl (url) {
  const { data } = await http.get('/user/h5/wx/work/getWorkUrl', {
    url
  })
  return data.data ? data.data.value : ''
}

/**
 * 企业微信 JS-SDK 授权
 */
export const wechatAuth = async (url) => {
  ww.register({
    corpId: 'ww5d448ccda627a91c', // 必填，当前用户企业所属企业ID
    jsApiList: ['closeWindow'], // 必填，需要使用的JSAPI列表
    getConfigSignature, // 必填，根据url生成企业签名的回调函数
    onConfigFail (res) {
      console.log('res: ', res)
    }
  })

  async function getConfigSignature (url) {
    // 根据 url 生成企业签名
    // 生成方法参考 https://developer.work.weixin.qq.com/document/path/90539
    return { }
  }
}

export const closeWindow = () => {
  ww.closeWindow()
}

export function isPC () {
  const userAgent = navigator.userAgent.toLowerCase()
  const pcKeywords = ['windows', 'macintosh']
  for (const keyword of pcKeywords) {
    if (userAgent.indexOf(keyword) !== -1) {
      return true
    }
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/ww-jssdk.js